export class NotificationRecordableCategory {
    public notificationRecordableCategoryId: number;
    public notificationId: number;
    public edhRecordableCategoryId: number;
}